import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,{style:({'font-size':''+_vm.valorFont+'px'}),attrs:{"id":"app"}},[_c(VMain,{attrs:{"fluid":""}},[_c('navUser',{attrs:{"id":"navusercont"}}),_c('transition',[_c('router-view',{staticClass:"cont-general"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }